import type { User } from '@/connect-types/user/user.type'

export enum AvailableRoles {
  SuperAdmin = 'Super Admin',
  Reseller = 'Reseller',
  Admin = 'Admin',
  Moderator = 'Moderator',
  GM = 'GM',
  Reports = 'Reports',
  Marketeer = 'Marketeer',
  Booking = 'Booking',
  FrontOfHouse = 'Front of House',
  ITSupport = 'IT Support',
}

// Display names shown in the UI (may differ from DB names)
export const RoleDisplayNames: Partial<Record<AvailableRoles, string>> = {
  [AvailableRoles.GM]: 'General Manager',
  [AvailableRoles.Booking]: 'Bookings Manager',
  [AvailableRoles.FrontOfHouse]: 'FOH',
  [AvailableRoles.ITSupport]: 'IT',
  [AvailableRoles.Marketeer]: 'Marketing',
}

// Frontend display order for roles (lower = shown first)
export const RoleSortOrder: Record<UserRoleType['key'], number> = {
  super: 0,
  reseller: 1,
  admin: 2,
  moderator: 3,
  gm: 4,
  booking: 5,
  'front-of-house': 6,
  marketeer: 7,
  'it-support': 8,
  reports: 9,
}

export interface UserRoleType {
  legacy_id: number
  name: AvailableRoles
  id: string
  key:
    | 'super'
    | 'reseller'
    | 'admin'
    | 'moderator'
    | 'gm'
    | 'reports'
    | 'marketeer'
    | 'booking'
    | 'front-of-house'
    | 'it-support'
}

export interface OrganisationUsersAccess {
  organization_id: string
  user_id: string
  role_id: string | 'no-edit'
  oauth_users: User
  role: UserRoleType
}
